export default function ArrowLink({ href, children, className = '', inverse = false }) {
  return (
    <a className={`arrow-link ${inverse ? 'arrow-link--inverse' : ''} ${className}`} href={href}>
      <span>{children}</span>
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 7l5 5-5 5" /></svg>
    </a>
  );
}
